import React from 'react';

import PropTypes from 'prop-types';
import Radio from '@tds/core-radio';

import Label from './label';
import { FieldOptionsGroup } from './css';
import { useLocaleContext } from '../../../context/LocaleContext';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';

const DefectWebform = ({
  fieldData,
  setFieldData,
  formErrors,
  setFormErrors
}) => {
  const locale = useLocaleContext();
  const {
    reportIssue: {
      form: {
        labelDefectWebform,
        labelDefectWebformOptionBusinessConnect,
        labelDefectWebformOptionWirelineSecurity,
        labelDefectWebformOptionWireless,
        labelDefectWebformOptionMyod,
        labelDefectWebformOptionPhoneNumberCheck,
        labelDefectWebformOptionContactCentre,
        labelDefectWebformOptionReferralTool,
        labelDefectWebformOptionInternetOfThings,
        labelDefectWebformOptionBusinessApps,
        labelDefectWebformOptionFullyManaged,
        labelDefectWebformOptionVulcanWebform
      }
    }
  } = locale === 'en-US' ? EN : FR;

  const fieldError = 'defectWebform' in formErrors;
  const fieldOptions = [
    labelDefectWebformOptionBusinessConnect,
    labelDefectWebformOptionWirelineSecurity,
    labelDefectWebformOptionWireless,
    labelDefectWebformOptionMyod,
    labelDefectWebformOptionPhoneNumberCheck,
    labelDefectWebformOptionContactCentre,
    labelDefectWebformOptionReferralTool,
    labelDefectWebformOptionInternetOfThings,
    labelDefectWebformOptionBusinessApps,
    labelDefectWebformOptionFullyManaged,
    labelDefectWebformOptionVulcanWebform
  ];

  const handleSelect = ({ target: { value } }) => {
    if (value)
      setFormErrors(previousValue => {
        const updatedValues = { ...previousValue };
        delete updatedValues.defectWebform;
        return updatedValues;
      });
    setFieldData(previousValue => ({
      ...previousValue,
      defectWebform: value
    }));
  };

  return (
    <div>
      <Label labelName={`${labelDefectWebform} *`} />
      {fieldError && (
        <div className="error-notification">
          <p>{formErrors.defectWebform.message}</p>
        </div>
      )}
      <FieldOptionsGroup>
        {fieldOptions.map(option => {
          return (
            <Radio
              checked={fieldData.defectWebform === option}
              onChange={handleSelect}
              name="defectWebform"
              value={option}
              label={option}
            />
          );
        })}
      </FieldOptionsGroup>
    </div>
  );
};

DefectWebform.propTypes = {
  formErrors: PropTypes.shape({
    defectWebform: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    defectWebform: PropTypes.string,
    defectCategory: PropTypes.string,
    priority: PropTypes.string,
    issueSummary: PropTypes.string,
    errorMessage: PropTypes.string,
    stepsToReplicate: PropTypes.string,
    attachment: PropTypes.string
  }).isRequired
};

export default DefectWebform;
